import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/CMLLOGO-01.png';
const _hoisted_1 = {
  class: "page js_show",
  style: {
    "background-color": "#F2F2F2"
  }
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "0 auto",
    "width": "200px",
    "height": "53px",
    "margin-top": "5px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "100%",
    "height": "53px"
  }
})], -1);
const _hoisted_3 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_4 = {
  key: 0,
  style: {
    "width": "90%",
    "margin": "0px auto"
  }
};
const _hoisted_5 = {
  class: "box",
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "titlecss"
}, "個人訊息：", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "姓       名：", -1);
const _hoisted_8 = {
  class: "datavalue"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "手機號碼：", -1);
const _hoisted_10 = {
  class: "datavalue"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "Email     ：", -1);
const _hoisted_12 = {
  class: "datavalue"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "性       別：", -1);
const _hoisted_14 = {
  class: "datavalue"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "生       日：", -1);
const _hoisted_16 = {
  class: "datavalue"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "所在區域：", -1);
const _hoisted_18 = {
  class: "datavalue"
};
const _hoisted_19 = {
  class: "box",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "titlecss"
}, "公司訊息：", -1);
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "統一編號：", -1);
const _hoisted_22 = {
  class: "datavalue"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "公司名稱：", -1);
const _hoisted_24 = {
  class: "datavalue"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "datatext"
}, "DBS編號：", -1);
const _hoisted_26 = {
  class: "datavalue"
};
const _hoisted_27 = {
  class: "box",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "titlecss"
}, "感興趣的產品-工程機械類：", -1);
const _hoisted_29 = {
  class: "box",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "titlecss"
}, "感興趣的產品-能源運輸類：", -1);
const _hoisted_31 = {
  key: 1,
  id: "nodata",
  style: {
    "margin": "0 auto",
    "text-align": "center"
  }
};
const _hoisted_32 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_ctx.isrequest == 0 ? (_openBlock(), _createBlock(_component_van_loading, {
    key: 0,
    style: {
      "margin-top": "40%"
    },
    vertical: ""
  }, {
    default: _withCtx(() => [_createTextVNode("加載中...")]),
    _: 1
  })) : _createCommentVNode("", true)]), _ctx.isrequest == 1 && _ctx.Name != '' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", null, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Name), 1)]), _createElementVNode("div", null, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.ContactNumber), 1)]), _createElementVNode("div", null, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.Email), 1)]), _createElementVNode("div", null, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.Gender), 1)]), _createElementVNode("div", null, [_hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.Birthday), 1)]), _createElementVNode("div", null, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.Location), 1)])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", null, [_hoisted_21, _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.TaxNumber), 1)]), _createElementVNode("div", null, [_hoisted_23, _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.CustomerName), 1)]), _createElementVNode("div", null, [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.CustomerNO), 1)])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.InterestList1, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "listvalue"
    }, [_createElementVNode("div", null, _toDisplayString(item), 1)]);
  }), 128))]), _createElementVNode("div", _hoisted_29, [_hoisted_30, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.InterestList2, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "listvalue"
    }, [_createElementVNode("div", null, _toDisplayString(item), 1)]);
  }), 128))])])) : _createCommentVNode("", true), _ctx.isrequest == 1 && _ctx.Name == '' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_van_empty, {
    description: "客戶信息不存在"
  })])) : _createCommentVNode("", true)]), _createVNode(_component_van_tabbar, {
    modelValue: _ctx.active,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.active = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      replace: "",
      icon: "cart-o",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.TabChage('HomeIndex'))
    }, {
      default: _withCtx(() => [_createTextVNode("服務中心")]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.TabChage('UE'))
    }, {
      icon: _withCtx(props => [_createElementVNode("img", {
        src: props.active == 1 ? 'https://lineqa.cml-tw.com.tw/wj-active.png' : 'https://lineqa.cml-tw.com.tw/wj-inactive.png'
      }, null, 8, _hoisted_32)]),
      default: _withCtx(() => [_createTextVNode("二手設備 ")]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      icon: "contact",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.TabChage('CustomerInfo'))
    }, {
      default: _withCtx(() => [_createTextVNode("會員訊息")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])], 64);
}